'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('oem_main.oem_user_index', {
    url: '/user_index',
    template: '<oem-user-index></oem-user-index>'
  });
};



// WEBPACK FOOTER //
// ./public/dev/app/oem/oem_user/index/oem_user_index.routes.js